(function ($) {
    $('a[href="#"]').click(function (e) {e.preventDefault();});
    $('input[type="tel"]').inputmask("+7 (999) 999-9999");

    $('#main-slider .slider').slick({
        autoplay: true,
        dots: true,
        // infinite: true,
        pauseOnFocus: false,
        arrows: false,
        // variableWidth: true,
        // adaptiveHeight: true
        appendDots: '#main-slider'
    });

    $('#faq .slider').slick({
        autoplay: true,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>'
    });

/*    $('.header-menu').slicknav({
        label: 'МЕНЮ',
        allowParentLinks: true,
        appendTo:'header'
    });*/

    $('.contacts-slider').slick({
        autoplay: true,
        pauseOnFocus: false,
        arrows: true,
    });

    $('.main-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.thumb-slider'
    });
    $('.thumb-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.main-slider',
        //dots: true,
        centerMode: true,
        focusOnSelect: true,
        //arrows: false,
        swipeToSlide: true,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>'
    });

    $(".fancy-modal-show").fancybox({
        baseClass: "fancy-modal-box",
    });
    $('#send-request .wpcf7, #request-phone .wpcf7').on('wpcf7mailsent', function () {
        $.fancybox.close();
    });

    $(window).scroll(function() {
        if($(this).scrollTop() >= 105.5) {
            $('body').addClass("sticky-menu");
        }
        else{
            $('body').removeClass("sticky-menu");
        }
    });

    $('.fancybox-thumb').fancybox({
        /*thumbs: {
            autoStart: true,
            axis: "x"
        },*/
        /*fullScreen : {
            autoStart: true
        },*/
        loop: true,
        baseClass: document.location.href.indexOf('proektyi') == -1 ? "f-thumb" : "f-thumb",
        smallBtn: true,
        clickContent: false,
        backFocus: false,
        mobile: {
            thumbs: {
                autoStart: false
            },
            preventCaptionOverlap: false
        }
    });

    $('.entry a[href^=\\#]').on('click', function(event){
        event.preventDefault();
        $('html,body').animate( { scrollTop: jQuery( this.hash ).offset().top -70 }, 1000 );
    });

    $(window).on('resize load', function() {
        ml = $('.footer-contacts').position().left - 16;
        $('.footer-menu li').css({"margin-left": ((ml > 0) && ($(window).width() < '992') ? ml : 0) + "px"});
        if ($(window).width() < '576')
            $('.show-action').appendTo('#main-slider');
        else
            $('.show-action').insertBefore('.slider-text > div > a')
    });

    /*$('body').on('mousemove', '.fancybox-image', function (e) {
        var part = $(window).width()/3,
            width = $(window).width();
        if ((e.clientX < part) || (e.clientX > width - part))
            $(this).css('cursor','pointer');
        else
            $(this).css('cursor','hand');
    });*/

    $('body').on('click', '.fancybox-image', function (e) {
        var part = $(window).width()/2,
            width = $(window).width(),
            instance = $.fancybox.getInstance();
        if(e.clientX < part)
            instance.previous();
        else if (e.clientX > width - part)
            instance.next();
    })
}(jQuery));